module.exports = __webpack_public_path__ + "img/cucc.2aa4efc4.png";